import React from 'react';
import disposable from '../assets/disposable.png';
import { Link } from 'react-router-dom';

const Disposable = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-12 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-6xl mx-auto">
        
        {/* Main Product Card */}
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-blue-50 flex flex-col lg:flex-row-reverse items-center">
          
          {/* Image Section - Right on Desktop */}
          <div className="lg:w-1/2 p-8 bg-[#e0f2fe] flex justify-center items-center relative min-h-[400px]">
            {/* Decorative background shape */}
            <div className="absolute inset-0 bg-gradient-to-br from-blue-100 to-transparent opacity-50"></div>
            
            <img 
              src={disposable}
              alt="360 Degree Protection Disposable Period Panty"
              className="relative z-10 w-full h-auto max-w-sm drop-shadow-2xl rounded-lg transform transition duration-500 hover:scale-105"
            />
          </div>

          {/* Content Section - Left on Desktop */}
          <div className="lg:w-1/2 p-8 lg:p-16">
            <span className="inline-block px-3 py-1 rounded-full bg-blue-100 text-blue-700 text-xs font-bold uppercase tracking-wider mb-4">
              Maximum Overnight Security
            </span>
            <h1 className="text-4xl font-extrabold text-slate-900 leading-tight mb-6">
              Total Freedom with <br />
              <span className="text-blue-600">360° Leak Protection</span>
            </h1>
            
            <p className="text-slate-600 text-lg mb-8 leading-relaxed">
              Say goodbye to stained sheets and bulky layering. Our disposable period panties 
              offer a seamless, body-hugging fit that moves with you, providing the ultimate 
              safety net for your heaviest days and longest nights.
            </p>

            {/* The "1 = 5" Power Feature */}
            <div className="mb-10 p-6 bg-blue-600 rounded-2xl text-white shadow-lg shadow-blue-200 flex items-center justify-between">
              <div className="flex-1">
                <h3 className="text-2xl font-bold">The Power of Five</h3>
                <p className="text-blue-100 opacity-90">Superior absorption in a single garment.</p>
              </div>
              <div className="text-4xl font-black bg-white text-blue-600 px-4 py-2 rounded-xl">
                1=5
              </div>
            </div>

            {/* Feature Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="flex gap-3">
                <div className="mt-1 text-blue-500">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" /></svg>
                </div>
                <div>
                  <h4 className="font-bold text-slate-800">Seamless Fit</h4>
                  <p className="text-sm text-slate-500">Invisible under clothes with a 360° stretch waistband.</p>
                </div>
              </div>

              <div className="flex gap-3">
                <div className="mt-1 text-blue-500">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" /></svg>
                </div>
                <div>
                  <h4 className="font-bold text-slate-800">Breathable Fabric</h4>
                  <p className="text-sm text-slate-500">Cotton-soft material that prevents heat and moisture buildup.</p>
                </div>
              </div>

              <div className="flex gap-3">
                <div className="mt-1 text-blue-500">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" /></svg>
                </div>
                <div>
                  <h4 className="font-bold text-slate-800">Toxin Free</h4>
                  <p className="text-sm text-slate-500">No chlorine, fragrance, or harsh chemicals. Rash-free guaranteed.</p>
                </div>
              </div>

              <div className="flex gap-3">
                <div className="mt-1 text-blue-500">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" /></svg>
                </div>
                <div>
                  <h4 className="font-bold text-slate-800">Zero Leakage</h4>
                  <p className="text-sm text-slate-500">Full front-to-back coverage for complete peace of mind.</p>
                </div>
              </div>
            </div>

            <Link to="/products" className="mt-10 w-full px-8 py-4 bg-slate-900 hover:bg-slate-800 text-white font-bold rounded-xl transition-all duration-300 transform hover:scale-[1.02]">
              Shop Heavy Flow Comfort
            </Link>
          </div>
        </div>

        {/* Comparison Footer */}
        <div className="mt-8 text-center text-slate-400 text-sm">
          <p>Ideal for: Heavy Cycles • Postpartum Recovery • Overnight Protection • Long Travels</p>
        </div>

      </div>
    </div>
  );
};

export default Disposable;